const isNewRelicAvailable = () => {
    return typeof window !== 'undefined' && 'newrelic' in window;
  };
  
  // Track page view
  export const trackPageView = (pageName: string, attributes?: Record<string, any>) => {
    if (isNewRelicAvailable()) {
      try {
        // @ts-ignore
        window.newrelic.setPageViewName(pageName);
        if (attributes) {
          // @ts-ignore
          window.newrelic.addPageAction('pageView', {
            ...attributes,
            pageName
          });
        }
        console.log(`[NewRelic] Tracked page view: ${pageName}`);
      } catch (error) {
        console.error('[NewRelic] Error tracking page view:', error);
      }
    }
  };
  
  // Track custom event
  export const trackEvent = (eventName: string, attributes?: Record<string, any>) => {
    if (isNewRelicAvailable()) {
      try {
        // @ts-ignore
        window.newrelic.addPageAction(eventName, attributes);
        console.log(`[NewRelic] Tracked event: ${eventName}`, attributes);
      } catch (error) {
        console.error('[NewRelic] Error tracking event:', error);
      }
    }
  };
  
  // Track error
  export const trackError = (error: Error, context?: Record<string, any>) => {
    if (isNewRelicAvailable()) {
      try {
        // @ts-ignore
        window.newrelic.noticeError(error, context);
        console.log('[NewRelic] Tracked error:', error.message);
      } catch (err) {
        console.error('[NewRelic] Error tracking error:', err);
      }
    }
  };